import { Phone, TrendingDown, TrendingUp } from "lucide-react";
import { observer } from "mobx-react";
import { SalesData as ApiSalesData } from 'randmar-api-client';
import { SalesData as LegacySalesData } from '../../stores/manufacturer/Manufacturer';

interface IProps {
  salesData?: LegacySalesData | ApiSalesData;
  fontSize?: "inherit" | "small" | "large" | undefined;
}

const SalesTrendingIcon = observer(({ salesData: rawSalesData, fontSize }: IProps) => {
  const isLegacy = (sd: LegacySalesData | ApiSalesData | undefined): sd is LegacySalesData => !!sd && 'salesLast30Days' in sd;

  const salesData: ApiSalesData | undefined = isLegacy(rawSalesData)
    ? {
        SalesLast30Days: rawSalesData.salesLast30Days,
        SalesLast3Months: rawSalesData.salesLast3Months,
        SalesYearToDay: rawSalesData.salesYearToDay,
      }
    : rawSalesData;

  let sizeClass: string;
  switch (fontSize) {
    case "small":
      sizeClass = "h-5 w-5";
      break;
    case "large":
      sizeClass = "h-9 w-9";
      break;
    case "inherit":
      sizeClass = "h-[1em] w-[1em]";
      break;
    default:
      sizeClass = "h-6 w-6";
  }

  const salesLast30Days = salesData?.SalesLast30Days || 0;
  const salesLast3Months = salesData?.SalesLast3Months || 0;

  if (salesLast30Days === 0) {
    return <Phone className={`${sizeClass} text-gray-500`} />;
  }

  const avgSalesLast3Months = salesLast3Months / 3;

  if (salesLast30Days > avgSalesLast3Months) {
    return <TrendingUp className={`${sizeClass} text-green-700`} />;
  }

  return <TrendingDown className={`${sizeClass} text-red-700`} />;
});

export default SalesTrendingIcon;
